export const API_BASE_URL = "https://dev-api.beemxyz.com/api/v1"
// export const API_BASE_URL = "http://192.168.29.253:7009/api/v1";
export const MEDIA_URL = "https://beemzbucket.s3.amazonaws.com/uploads/images/";

export const ApiEndPoints = {
  AUTH: {
    login: `${API_BASE_URL}/admin/login`,
    me: `${API_BASE_URL}/admin/profile`,
  },

  FAST_MARKET: {
    getAllAds: `${API_BASE_URL}/add/all-item`,
    updateAdStatus: (adsId) => `${API_BASE_URL}/add/update/${adsId}`,
  },
  FAST_MARKET_INVOICE: {
    getInvoice: (adsId) => `${API_BASE_URL}/add/${adsId}`,
    getInvoicePDF: (adsId) => `${API_BASE_URL}/add/ad-invoice/${adsId}`,
  },

  ADD_SETTINGS: {
    adsSettingsTest: `${API_BASE_URL}/add-setting/test`,
    adsSettingsGet: `${API_BASE_URL}/add-setting`,
    adsSettingsUpdate: `${API_BASE_URL}/add-setting/update-all`,
    adsSettingsGetTest: `${API_BASE_URL}/add-setting/test/settings`,
  },

  TAX_SETTINGS: {
    taxSettingsAdd: `${API_BASE_URL}/tax-setting`,
    taxSettingsGet: `${API_BASE_URL}/tax-setting`,
  },

  COUNTRY_REGION: {
    getCountry: `${API_BASE_URL}/country/all`,
    getState: (code) => `${API_BASE_URL}/country/region/all/${code}`,
  },

  TIER_SETTINGS: {
    tierSettingsGet: `${API_BASE_URL}/subscription-plan`,
    tierSettingsUpdate: `${API_BASE_URL}/subscription-plan/bulk-update`,
    tierSettingsUpdateKey: (featureId) =>
      `${API_BASE_URL}/subscription-feature/${featureId}/update-key`,
  },

  CURRENCY_SETTINGS: {
    currencyGet: `${API_BASE_URL}/currency`,
    currencyUpdate: (currencyId) => `${API_BASE_URL}/currency/${currencyId}/minimum-amount`,
  },

  BUSINESS_WALLET: {
    getBusinessList: `${API_BASE_URL}/business/list`,
    getBusinessLocation: (businessId) => `${API_BASE_URL}/business-location/${businessId}`,
    getWalletLocation: (businessId) => `${API_BASE_URL}/wallet/business/${businessId}/locations`,
    getWalletTotal: (businessId, currency) => `${API_BASE_URL}/wallet/business/${businessId}/total?currency=${currency}`,
    getTotalBusinessWalletBalance: (currency, timePeriod = "all time") => `${API_BASE_URL}/wallet/business/total?currency=${currency}&timePeriod=${encodeURIComponent(timePeriod)}`,
    getBankAccounts: (locationId) => `${API_BASE_URL}/bank-account/business-location/${locationId}`,
    approveBankAccount: (accountId) => `${API_BASE_URL}/bank-account/${accountId}/approve`,
    rejectBankAccount: (accountId) => `${API_BASE_URL}/bank-account/${accountId}/reject`,
  },

  CURRENCY: {
    getCurrencies: `${API_BASE_URL}/currency`,
  },

  WALLET_LIMIT: {
    createWalletLimit: `${API_BASE_URL}/wallet-limit`,
    getAllWalletLimits: `${API_BASE_URL}/wallet-limit`,
    getWalletLimitByCountryAndCurrency: (country, currency) => `${API_BASE_URL}/wallet-limit/country/${country}/currency/${currency}`,
    getWalletLimitById: (limitId) => `${API_BASE_URL}/wallet-limit/${limitId}`,
    updateWalletLimit: (limitId) => `${API_BASE_URL}/wallet-limit/${limitId}`,
    deleteWalletLimit: (limitId) => `${API_BASE_URL}/wallet-limit/${limitId}`,
  },

  CASHOUT_ADMIN: {
    getCashoutTable: `${API_BASE_URL}/cashout/getAll-cashout`,
    getTotalCashout: `${API_BASE_URL}/cashout/total-cashout`,
    getStatusCounts: `${API_BASE_URL}/cashout/status-counts`,
    getCashoutDetails: (requestId) => `${API_BASE_URL}/cashout/${requestId}`,
    bulkAction: `${API_BASE_URL}/cashout/bulk-action`,
  },

  BUSINESS_SUBSCRIPTION: {
    getTotalPayments: `${API_BASE_URL}/admin/business/subscriptions/total-payments`,
    getActiveSubscriptions: `${API_BASE_URL}/admin/business/subscriptions/active`,
    getDeactivations: `${API_BASE_URL}/admin/business/subscriptions/deactivations`,
    getSubscriptionTable: `${API_BASE_URL}/admin/business/subscriptions/table`,
    getBusinessSubscriptions: (businessId) => `${API_BASE_URL}/admin/business/subscriptions-transactions/${businessId}`,
    updateBusinessStatus: (businessId) => `${API_BASE_URL}/admin/business/${businessId}/status`,
  },
};
